/* landing-notrufuhr-extra.js
   Scarcity-Counter, Direkt-Kontakt-Live-Status, Exit-Intent für die bestehende LP */
(function () {
  'use strict';

  // ─── Telefon-Öffnungszeit (Mo–Fr 08–17 Europe/Berlin) ─────────────────────
  function isPhoneOpen() {
    try {
      var parts = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin',
        weekday: 'short',
        hour: '2-digit',
        hour12: false
      }).formatToParts(new Date());
      var weekday = '', hour = 0;
      parts.forEach(function (p) {
        if (p.type === 'weekday') weekday = p.value;
        if (p.type === 'hour') hour = parseInt(p.value, 10);
      });
      return /^(Mo|Di|Mi|Do|Fr)/i.test(weekday) && hour >= 8 && hour < 17;
    } catch (e) {
      var d = new Date(), day = d.getDay(), h = d.getHours();
      return day >= 1 && day <= 5 && h >= 8 && h < 17;
    }
  }

  function applyContactState() {
    var open = isPhoneOpen();
    var dPhone = document.getElementById('lp-direct-phone');
    var dWA = document.getElementById('lp-direct-whatsapp');
    if (dPhone && dWA) {
      dPhone.setAttribute('data-state', open ? 'primary' : 'secondary');
      dWA.setAttribute('data-state', open ? 'secondary' : 'primary');
    }
    var status = document.getElementById('lp-contact-status');
    var statusText = document.getElementById('lp-status-text');
    if (status && statusText) {
      if (open) {
        statusText.textContent = 'Jetzt telefonisch erreichbar';
        status.className = 'lp-contact-direct__status is-open';
      } else {
        statusText.textContent = 'Außerhalb der Servicezeit · WhatsApp antwortet am nächsten Werktag';
        status.className = 'lp-contact-direct__status is-closed';
      }
    }
  }

  // ─── Scarcity (19 Plätze, deterministisch pro Wochentag) ─────────────────
  function initScarcity() {
    var leftEl = document.getElementById('lp-scarcity-left');
    var numEl = document.getElementById('lp-scarcity-num');
    if (!leftEl || !numEl) return;
    try {
      var parts = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', weekday: 'short' }).formatToParts(new Date());
      var weekday = (parts.find(function (p) { return p.type === 'weekday'; }) || {}).value || '';
      var key = weekday.replace('.', '').slice(0, 2);
      var map = { Mo: 19, Di: 15, Mi: 11, Do: 8, Fr: 5, Sa: 3, So: 3 };
      var left = map[key] || 12;
      numEl.textContent = left;
      leftEl.textContent = left === 1 ? 'Platz frei' : 'Plätze frei';
    } catch (e) {}
  }

  // ─── Exit-Intent ──────────────────────────────────────────────────────────
  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (r, v) {
      var p = v.split('=');
      return p[0] === name ? decodeURIComponent(p[1]) : r;
    }, '');
  }

  function initExitIntent() {
    var popup = document.getElementById('lp-exit');
    if (!popup) return;
    var SHOWN = 'ln_exit_shown';
    if (sessionStorage.getItem(SHOWN) === '1') return;

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      sessionStorage.setItem(SHOWN, '1');
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'ln_exit_show' }); } catch (e) {}
    }
    function hide() {
      popup.hidden = true;
      document.body.style.overflow = '';
    }

    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) show();
    });

    var lastY = window.scrollY, openedAt = Date.now(), scrolledDown = false;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 600) scrolledDown = true;
      if (scrolledDown && y < 200 && (lastY - y) > 80 && (Date.now() - openedAt) > 15000) show();
      lastY = y;
    }, { passive: true });

    setTimeout(function () { if (!document.hidden) show(); }, 45000);

    popup.addEventListener('click', function (e) {
      if (e.target.matches('[data-lp-exit-close]')) hide();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) hide();
    });

    var form = document.getElementById('lp-exit-form');
    var succ = document.getElementById('lp-exit-success');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        if ((fd.get('_hp') || '').toString().trim() !== '') { ok(); return; }
        var email = (fd.get('email') || '').toString();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          var inp = form.querySelector('input[type="email"]'); if (inp) inp.focus();
          return;
        }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet …'; }
        var payload = {
          email: email,
          source: 'landing-notrufuhr-exit',
          page_url: location.href,
          referrer: document.referrer || '',
          fbc: getCookie('_fbc') || '',
          fbp: getCookie('_fbp') || '',
          ts: new Date().toISOString()
        };
        var url = (window.LUADA_LEAD_CONFIG && window.LUADA_LEAD_CONFIG.webhookUrl) || 'https://webhook.luada.de/lead';
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          mode: 'cors',
          credentials: 'omit'
        }).then(function () {
          ok();
          try { if (window.fbq) window.fbq('track', 'Lead', { content_name: 'exit_brochure' }); } catch (e) {}
          try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'ln_exit_submit' }); } catch (e) {}
        }).catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Broschüre kostenlos zusenden'; }
        });
      });
    }
    function ok() {
      if (form) form.hidden = true;
      if (succ) succ.hidden = false;
      setTimeout(hide, 4000);
    }
  }

  function init() {
    applyContactState();
    setInterval(applyContactState, 5 * 60 * 1000);
    initScarcity();
    initExitIntent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
